export default "__VITE_ASSET__42370025__"